/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type GenerateLowHighSuggestionsInput = {
    projectId?: string | null | undefined;
    tasks?: Array<LowHighSuggestionInput | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type LowHighSuggestionInput = {
    taskId?: string | null | undefined;
    roleId?: string | null | undefined;
};
export type generateLowHighSuggestionsMutationVariables = {
    input: GenerateLowHighSuggestionsInput;
};
export type generateLowHighSuggestionsMutationResponse = {
    readonly generateLowHighSuggestions: {
        readonly suggestions: ReadonlyArray<{
            readonly id: string;
            readonly taskId: string;
            readonly low: number | null;
            readonly high: number | null;
            readonly estimate: number | null;
        } | null> | null;
    } | null;
};
export type generateLowHighSuggestionsMutation = {
    readonly response: generateLowHighSuggestionsMutationResponse;
    readonly variables: generateLowHighSuggestionsMutationVariables;
};



/*
mutation generateLowHighSuggestionsMutation(
  $input: GenerateLowHighSuggestionsInput!
) {
  generateLowHighSuggestions(input: $input) {
    suggestions {
      id
      taskId
      low
      high
      estimate
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "GenerateLowHighSuggestionsInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateLowHighSuggestionsPayload",
    "kind": "LinkedField",
    "name": "generateLowHighSuggestions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SuggestedLowHigh",
        "kind": "LinkedField",
        "name": "suggestions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taskId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "low",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "high",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimate",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "generateLowHighSuggestionsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "generateLowHighSuggestionsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "generateLowHighSuggestionsMutation",
    "operationKind": "mutation",
    "text": "mutation generateLowHighSuggestionsMutation(\n  $input: GenerateLowHighSuggestionsInput!\n) {\n  generateLowHighSuggestions(input: $input) {\n    suggestions {\n      id\n      taskId\n      low\n      high\n      estimate\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '88e51dc28fdbd94527f9b7916dc86fd4';
export default node;
